import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/**
 * Shared chrome for public customer-portal surfaces (landing + auth).
 * Visual language matches paznetworks.com: dark navy header, Manrope
 * wordmark, rust CTA, cool-gray page background.
 */
export function PublicSiteFrame({
  children,
  showSignIn = true,
}: {
  children: ReactNode;
  showSignIn?: boolean;
}) {
  return (
    <div className="public-site min-h-screen flex flex-col">
      <header className="public-nav">
        <div className="public-nav-inner">
          <Link to="/" className="public-wordmark" aria-label="PazNetworks home">
            PazNetworks
          </Link>
          {showSignIn && (
            <Link to="/login" className="public-nav-link">
              Sign in
            </Link>
          )}
        </div>
      </header>
      <div className="flex-1 flex flex-col">{children}</div>
      <footer className="public-footer">
        <div className="public-footer-inner">
          <span>&copy; {new Date().getFullYear()} PazNetworks, Inc.</span>
          <div className="flex gap-5">
            <a href="https://paznetworks.com/privacy" target="_blank" rel="noreferrer">
              Privacy
            </a>
            <a href="https://paznetworks.com/terms" target="_blank" rel="noreferrer">
              Terms
            </a>
            <Link to="/health">Status</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
